import type { FC } from 'react';

import { useListNotifications } from 'hooks/use-list-copilot-notifications';

export const CopilotNotifications: FC = (): null => {
  useListNotifications();

  return null;
};
